/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// Datatable offsets
import { tableSchemaBase as columns } from '../offsets.columns';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IOffsetsDatatableSlice {
	offsetsDatatableOptions: any[];
	setOffsetsDatatableOptions: (
		_offsetsDatatableOptions: any[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeOffsetsDatatableSlice = (
	s: any
): any => ({
	offsetsDatatableOptions: s.offsetsDatatableOptions,
});

const initialState = {
	offsetsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createOffsetsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', any]],
	[],
	IOffsetsDatatableSlice
> = (set) => ({
	...initialState,
	setOffsetsDatatableOptions: (
		_offsetsDatatableOptions: any[]
	) =>
		set({
			offsetsDatatableOptions: _offsetsDatatableOptions,
		}),
});
